<block-ui></block-ui>
<div *ngIf="ShowPageContent" class="container-fluid">
  <!-- begin::Header -->
  <div class="card card-custom-h">
    <div class="card-header border-0 pt-5">
      <div class="card-title align-items-start flex-column" *ngIf="IsFilterLoaded">
        <form [formGroup]="UsersForm">
          <BBSF-TextBox [options]="searchTextBox" [group]="UsersForm"></BBSF-TextBox>
        </form>
      </div>
      <div class="card-toolbar">
        <!-- begin::Menu -->
        <div *ngIf="showGeneralBtns" ngbDropdown class="d-inline-block" [ngStyle]="{'display': ShowPageContent==true?'block':'none'}">
          <button (click)="loadLists()" ngbDropdownToggle href="javascript:;" type="button" class="btn btn-sm btn-light-primary me-3" id="FiltersDropdown" title="Filter">
            <i class="fas fa-filter me-1"></i>
            {{utilityService.getResourceValue("Filter")}}
          </button>
          <div *ngIf="IsFilterLoaded" ngbDropdownMenu aria-labelledby="FiltersDropdown" class=" filter-container menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary  w-250px w-md-500px fw-bold py-3 ">
            <form [formGroup]="UsersForm">
              <div class="px-7 py-5">
                <div class="row">
                  <div class="col-lg-6">
                    <div class="mb-10">
                      <BBSF-DropdownList #permissionSetDDL [options]="permissionSetsOptions" [group]="UsersForm"></BBSF-DropdownList>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="mb-10">
                      <BBSF-DropdownList #accountStatusDDL [options]="accountStatusOptions" [group]="UsersForm"></BBSF-DropdownList>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="mb-10">
                      <BBSF-DropdownList #lockedStatusDDL [options]="lockedStatusOptions" [group]="UsersForm"></BBSF-DropdownList>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="mb-10">
                      <BBSF-DropdownList #departmentsDDL [options]="departmentsOptions" [group]="UsersForm"></BBSF-DropdownList>
                    </div>
                  </div>
                </div>
                <div class="d-flex justify-content-end">
                  <button class="btn btn-light btn-active-light-primary pv-reset btn-sm" id="applyFiltersBtn"
                          (click)="resetFilters()">
                    {{utilityService.getResourceValue("Reset")}}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <button *ngIf="showGeneralBtns" href="javascript:;" type="button" (click)="exportExcel()" class="btn btn-sm btn-light-primary me-3 bnsights-btn-export"
                title="Export">
          <i class="fas fa-download me-1"></i>
          {{utilityService.getResourceValue("Export")}}
        </button>
        <button *ngIf="showActivateBtn" type="button" id="btnActivate" class="btn btn-sm btn-light-primary me-3" href="javascript:;" data-toggle="modal"
                data-target="#ConfirmationModal" (click)="showConfirmationModal(1, ConfirmationModal)">
          <i class="fa fa-history"></i> {{utilityService.getResourceValue("Activate")}}
        </button>
        <button *ngIf="showDeactivateBtn" type="button" id="btnDeactivate" class="btn btn-sm btn-light-primary me-3" href="javascript:;" data-toggle="modal"
                data-target="#ConfirmationModal" (click)="showConfirmationModal(2, ConfirmationModal)">
          <i class="fa fa-power-off"></i>{{utilityService.getResourceValue("Deactivate")}}
        </button>
        <button *ngIf="showResetPassBtn" type="button" id="btnResetPass" class="btn btn-sm btn-light-primary me-3" href="javascript:;" data-toggle="modal"
                data-target="#ConfirmationModal" (click)="showConfirmationModal(3, ConfirmationModal)">
          <i class="fa fa-cog"></i>{{utilityService.getResourceValue("ResetPassword")}}
        </button>
        <button *ngIf="showSendEmailBtn" type="button" id="btnResendActivation" class="btn btn-sm btn-light-primary me-3" href="javascript:;" data-toggle="modal"
                data-target="#ConfirmationModal" (click)="showConfirmationModal(4 , ConfirmationModal)">
          <i class="fa fa-envelope"></i> {{utilityService.getResourceValue("SendActivationEmail")}}
        </button>
        <button *ngIf="showGeneralBtns" type="button" class="btn btn-sm btn-primary" title="Add" (click)="showAddUserModal(addUserModal)">
          <i class="fas fa-plus me-1"></i>
          {{utilityService.getResourceValue("Add")}}
        </button>
        <!-- end::Menu -->
      </div>
    </div>
    <!-- end::Header -->
    <!-- begin::Body -->
    <div class="card-body py-3">
      <!-- begin::Table container -->
      <div class="table-responsive">
        <!-- begin::Table -->
        <table class="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer">
          <thead>
            <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
              <th class="w-50px">
                <span>
                  <label class="form-check form-check-sm form-check-custom form-check-solid">
                    <mat-checkbox (change)="selectAllUserList($event,UserPagingResult)" [checked]="allSelected">
                    </mat-checkbox>
                    <!--<input type="checkbox" class="form-check-input" (change)="selectAllUserList($event,UserPagingResult)" id="chk_SelectAll">-->
                    &nbsp;<span></span>
                  </label>
                </span>
              </th>
              <th class="min-w-150px">{{utilityService.getResourceValue("Name")}}</th>
              <th class="min-w-150px">{{utilityService.getResourceValue("Email")}}</th>
              <th class="min-w-150px">{{utilityService.getResourceValue("Mobile")}}</th>
              <th class="min-w-150px">{{utilityService.getResourceValue("Roles")}}</th>
              <th class="min-w-150px">{{utilityService.getResourceValue("Status")}}</th>
              <th class="min-w-50px">{{utilityService.getResourceValue("Action")}}</th>
            </tr>
          </thead>
          <tbody id="listingContainer" class="fw-bold text-gray-600 border-0">
            <tr *ngFor="let user of UserPagingResult">
              <td>
                <span>
                  <label class="form-check form-check-sm form-check-custom form-check-solid">
                    <!--<input type="checkbox" class="form-check-input" (change)="updateUserList($event,user)" id="User-{{user.id}}">-->
                    <span></span>
                    <mat-checkbox (change)="updateUserList($event,user)" [(ngModel)]="user.selected">
                    </mat-checkbox>
                  </label>
                </span>
              </td>
              <td>
                <div class="d-flex align-items-center">
                  <div class="symbol symbol-35px">
                    <h6 class="symbol-label font-size-h5 font-weight-bold bg-light-primary ml-2 mb-0 me-3">A</h6>
                  </div>
                  <div class="d-flex justify-content-start flex-column">
                    <a *ngIf="language=='en'" data-toggle="modal" data-target="#EditUserModal"
                       (click)="showEditUserModal(user,EditUserModal)" href="javascript:void(0)" class="text-dark fw-bolder text-hover-primary fs-6">{{user.name.english}}</a>
                    <a *ngIf="language=='ar'" data-toggle="modal" data-target="#EditUserModal"
                       (click)="showEditUserModal(user,EditUserModal)" href="javascript:void(0)" class="text-dark fw-bolder text-hover-primary fs-6">{{user.name.arabic}}</a>
                  </div>
                </div>
              </td>
              <td>{{user.username}}</td>
              <td>{{user.mobile}}</td>
              <td>{{user.permissionset}}</td>
              <td>
                <span class="badge badge-light-success" *ngIf="user.isActive==true">
                  {{utilityService.getResourceValue("Activate")}}
                </span>
                <span class="badge badge-light-danger" *ngIf="user.isActive==false">
                  {{utilityService.getResourceValue("Deactivate")}}
                </span>
              </td>
              <td>
                <div>
                  <button mat-button [matMenuTriggerFor]="menu" class="btn btn-sm btn-icon btn-light btn-active-light-primary">
                    <i class="fa fa-ellipsis-h" aria-hidden="true"></i>
                  </button>
                  <mat-menu #menu="matMenu">
                    <button type="button" class="menu-item px-3" ngbDropdownItem
                            (click)="showEditUserModal(user,EditUserModal)">
                      <span class="menu-link px-3">{{utilityService.getResourceValue("Edit")}}</span>
                    </button>
                    <button ngbDropdownItem class="menu-item px-3" *ngIf="user.isActive" id="btnDeactivate" (click)="showActivateUserModal(user,false,ActivateUserModal)">
                      <span class="menu-link px-3">{{utilityService.getResourceValue("Deactivate")}}</span>
                    </button>
                    <button ngbDropdownItem class="menu-item px-3" id="btnactivate" (click)="showActivateUserModal(user,true,ActivateUserModal)" *ngIf="!user.isActive">
                      <span class="menu-link px-3">{{utilityService.getResourceValue("Activate")}}</span>
                    </button>
                    <button ngbDropdownItem class="menu-item px-3" id="btnResetPass" (click)="showResetPasswordUserModal(user , ResetPasswordUserModal)">
                      <span class="menu-link px-3">{{utilityService.getResourceValue("ResetPassword")}}</span>
                    </button>

                    <button ngbDropdownItem class="menu-item px-3" id="btnResetPass" (click)="showsetPasswordUserModal(user, setPasswordUserModal)">
                      <span class="menu-link px-3">{{utilityService.getResourceValue("SetPassword")}}</span>
                    </button>

                    <button ngbDropdownItem class="menu-item px-3" id="btnResetPass" *ngIf="!user.isActive" (click)="showSendActivationEmailModal(user , SendActivationEmailModal)">
                      <span class="menu-link px-3">{{utilityService.getResourceValue("SendActivationEmail")}}</span>
                    </button>
                  </mat-menu>


                </div>

              </td>
            </tr>
            <tr *ngIf="UserPagingResult.length == 0">
              <td colspan="6">
                <lib-empty-data></lib-empty-data>
              </td>
            </tr>
          </tbody>
        </table>
        <!-- end::Table -->
      </div>
      <!-- end::Table container -->
      <!-- begin paging-->
      <BBSF-Paging (Items)="setUsersListResult($event)" *ngIf="IsFilterLoaded" [options]="UserPaging"
                   [group]="UsersForm" #UserPagingViewElement>
      </BBSF-Paging>
      <!-- End paging-->
    </div>
  </div>
</div>

<!-- add user-->
<ng-template #addUserModal let-modal>
  <div class="modal-header pb-0 border-0 justify-content-end">
    <h5 class="modal-title" id="exampleModalLabel"></h5>
    <button type="button" data-dismiss="modal" aria-label="Close" (click)="modal.dismiss()" class="btn btn-sm btn-icon btn-active-color-primary">
      <span class="svg-icon svg-icon-1">
        <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
      </span>
    </button>
  </div>
  <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
    <div class="mb-13 text-center">
      <h1 class="mb-3">{{utilityService.getResourceValue("AddUser")}}</h1>
    </div>
    <form [formGroup]="AddUserForm" (ngSubmit)="addUser()">
      <BBSF-MultiLingualTextBox [options]="MultiLingualName" [group]="AddUserForm"></BBSF-MultiLingualTextBox>
      <BBSF-TextBox [options]="Username" [group]="AddUserForm"></BBSF-TextBox>
      <BBSF-TextBox [options]="SamAccount" [group]="AddUserForm"></BBSF-TextBox>
      <BBSF-Phone [options]="MobileNumber" [group]="AddUserForm"></BBSF-Phone>
      <BBSF-DropdownList [options]="UserDepartment" [group]="AddUserForm"></BBSF-DropdownList>
      <BBSF-Toggleslide [options]="SendActivationEmail" [group]="AddUserForm"></BBSF-Toggleslide>
      <BBSF-DropdownList [options]="UserPermissions" [group]="AddUserForm"></BBSF-DropdownList>
      <div class="text-center pt-7">
        <button type="button" #CloseUserModal id="CloseUserModal" data-dismiss="modal" aria-label="Close" class="btn btn-light me-3 btn-sm" (click)="modal.dismiss()">{{utilityService.getResourceValue("CancelLabel")}} </button>
        <button type="submit" class="btn btn-primary btn-sm">{{utilityService.getResourceValue("SaveLabel")}}</button>
      </div>
    </form>

  </div>
</ng-template>

<!-- Edit user-->
<ng-template #EditUserModal let-modal>
  <div class="modal-header pb-0 border-0 justify-content-end">
    <h5 class="modal-title" id="exampleModalLabel"></h5>
    <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-sm btn-icon btn-active-color-primary" (click)="modal.dismiss()">
      <span class="svg-icon svg-icon-1">
        <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
      </span>
    </button>
  </div>
  <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
    <div class="mb-13 text-center">
      <h1 class="mb-3">{{utilityService.getResourceValue("EditUser")}}</h1>
    </div>
    <form [formGroup]="EditUserForm" (ngSubmit)="editUser()">
      <BBSF-MultiLingualTextBox [options]="EditMultiLingualName" [group]="EditUserForm"></BBSF-MultiLingualTextBox>
      <BBSF-Phone [options]="EditMobileNumber" [group]="EditUserForm"></BBSF-Phone>
      <BBSF-TextBox [options]="EditUsername" [group]="EditUserForm"></BBSF-TextBox>
      <BBSF-TextBox [options]="EditEmail" [group]="EditUserForm"></BBSF-TextBox>
      <BBSF-TextBox [options]="EditSamAccount" [group]="EditUserForm"></BBSF-TextBox>
      <BBSF-DropdownList [options]="EditUserDepartment" [group]="EditUserForm"></BBSF-DropdownList>
      <BBSF-DropdownList [options]="EditUserPermissions" [group]="EditUserForm"></BBSF-DropdownList>
      <div class="text-center pt-7">
        <button type="button" data-dismiss="modal" #CloseEditUserModal id="CloseEditUserModal" aria-label="Close" class="btn btn-light me-3 btn-sm" (click)="modal.dismiss()">{{utilityService.getResourceValue("CancelLabel")}}</button>
        <button type="submit" class="btn btn-primary btn-sm">{{utilityService.getResourceValue("SaveLabel")}}</button>
      </div>
    </form>

  </div>
</ng-template>
<!-- Deactivate/Activate User Modal -->
<ng-template #ActivateUserModal let-modal>
  <div class="modal-header pb-0 border-0 justify-content-end">
    <h5 class="modal-title" id="exampleModalLabel"></h5>
    <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-sm btn-icon btn-active-color-primary" (click)="modal.dismiss()">
      <span class="svg-icon svg-icon-1">
        <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
      </span>
    </button>
  </div>
  <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
    <div class="mb-13 text-center">
      <h1 class="mb-3" *ngIf="!ShowActivateModelData" id="exampleModalLabel">
        {{utilityService.getResourceValue("Deactivate")}}
      </h1>
      <h1 class="mb-3" *ngIf="ShowActivateModelData" id="exampleModalLabel">
        {{utilityService.getResourceValue("Activate")}}
      </h1>
    </div>
    <div class="notice d-flex bg-light-warning rounded border-warning border border-dashed mb-10 p-6">
      <!--begin::Icon-->
      <!--begin::Svg Icon | path: icons/duotune/general/gen044.svg-->
      <span class="svg-icon svg-icon-2tx svg-icon-warning me-4">
        <span [inlineSVG]="'./src/assets/images/gen044.svg'"></span>
      </span>
      <!--end::Svg Icon-->
      <!--end::Icon-->
      <!--begin::Wrapper-->
      <div class="d-flex flex-stack flex-grow-1">
        <!--begin::Content-->
        <div class="fw-bold">
          <div class="fs-6 text-gray-700" *ngIf="!ShowActivateModelData">
            {{utilityService.getResourceValue("DeactivateConfirmation")}}
          </div>
          <div class="fs-6 text-gray-700" *ngIf="ShowActivateModelData">
            {{utilityService.getResourceValue("ActivateConfirmation")}}
          </div>
        </div>
        <!--end::Content-->
      </div>
      <!--end::Wrapper-->
    </div>
    <div id="" class="">
      <div class="table-responsive-x">
        <table id="tableConfirmation" class="table table-striped table-bordered ">
          <thead>
            <tr>
              <th>{{utilityService.getResourceValue("Name")}}</th>
              <th>{{utilityService.getResourceValue("Email")}}</th>
            </tr>
          </thead>
          <tbody>
            <tr class="trItem">
              <td>{{Name}}</td>
              <td>{{Email}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="text-center pt-7">
      <button type="button" #CloseActivateUserModal id="CloseActivateUserModal" data-dismiss="modal" aria-label="Close" class="btn btn-light me-3 btn-sm" (click)="modal.dismiss()">{{utilityService.getResourceValue("CancelLabel")}} </button>
      <button type="button" *ngIf="!ShowActivateModelData" (click)="deactivate()"
              class="btn btn-primary btn-sm">
        {{utilityService.getResourceValue("SaveLabel")}}
      </button>
      <button type="button" *ngIf="ShowActivateModelData" (click)="activate()"
              class="btn btn-primary btn-sm">
        {{utilityService.getResourceValue("SaveLabel")}}
      </button>

    </div>
  </div>
</ng-template>
<!-- ResetPassword User Modal -->
<ng-template #ResetPasswordUserModal let-modal>
  <div class="modal-header pb-0 border-0 justify-content-end">
    <h5 class="modal-title" id="exampleModalLabel"></h5>
    <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-sm btn-icon btn-active-color-primary" (click)="modal.dismiss()">
      <span class="svg-icon svg-icon-1">
        <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
      </span>
    </button>
  </div>
  <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
    <div class="mb-13 text-center">
      <h1 class="mb-3">{{utilityService.getResourceValue("ResetPassword")}}</h1>
    </div>
    <div class="notice d-flex bg-light-warning rounded border-warning border border-dashed mb-10 p-6">
      <!--begin::Icon-->
      <!--begin::Svg Icon | path: icons/duotune/general/gen044.svg-->
      <span class="svg-icon svg-icon-2tx svg-icon-warning me-4">
        <span [inlineSVG]="'./src/assets/images/gen044.svg'"></span>
      </span>
      <!--end::Svg Icon-->
      <!--end::Icon-->
      <!--begin::Wrapper-->
      <div class="d-flex flex-stack flex-grow-1">
        <!--begin::Content-->
        <div class="fw-bold">
          <div class="fs-6 text-gray-700">
            {{utilityService.getResourceValue("ResetPasswordConfirmation")}}
          </div>
        </div>
        <!--end::Content-->
      </div>
      <!--end::Wrapper-->
    </div>
    <div id="" class="">
      <div class="table-responsive">
        <!-- begin::Table -->
        <table class="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer">
          <thead>
            <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
              <th class="min-w-200">{{utilityService.getResourceValue("Name")}}</th>
              <th class="min-w-200">{{utilityService.getResourceValue("Email")}}</th>
            </tr>
          </thead>
          <tbody class="fw-bold text-gray-600 border-0">
            <tr class="trItem">
              <td class="text-dark">{{Name}}</td>
              <td>{{Email}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="text-center pt-7">
      <button id="CloseResetPasswordUserModal" #CloseResetPasswordUserModal type="button" data-dismiss="modal" aria-label="Close" class="btn btn-light me-3 btn-sm" (click)="modal.dismiss()">{{utilityService.getResourceValue("CancelLabel")}}</button>

      <button type="button" (click)="resetPassword()" class="btn btn-primary btn-sm">
        {{utilityService.getResourceValue("SaveLabel")}}
      </button>
    </div>
  </div>
</ng-template>

<!-- setPassword User Modal -->
<ng-template #setPasswordUserModal let-modal>
  <div class="modal-header pb-0 border-0 justify-content-end">
    <h5 class="modal-title" id="exampleModalLabel"></h5>
    <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-sm btn-icon btn-active-color-primary" (click)="modal.dismiss()">
      <span class="svg-icon svg-icon-1">
        <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
      </span>
    </button>
  </div>
  <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
    <div class="mb-13 text-center">
      <h1 class="mb-3">{{utilityService.getResourceValue("SetPassword")}}</h1>
    </div>
    <div class="notice d-flex bg-light-warning rounded border-warning border border-dashed mb-10 p-6">
      <!--begin::Icon-->
      <!--begin::Svg Icon | path: icons/duotune/general/gen044.svg-->
      <span class="svg-icon svg-icon-2tx svg-icon-warning me-4">
        <span [inlineSVG]="'./src/assets/images/gen044.svg'"></span>
      </span>
      <!--end::Svg Icon-->
      <!--end::Icon-->
      <!--begin::Wrapper-->
      <div class="d-flex flex-stack flex-grow-1">
        <!--begin::Content-->
        <div class="fw-bold">
          <div class="fs-6 text-gray-700">
            {{utilityService.getResourceValue("SetPasswordConfirmation")}}
          </div>
        </div>
        <!--end::Content-->
      </div>
      <!--end::Wrapper-->
    </div>
    <form [formGroup]="SetUserPasswordForm" (ngSubmit)="setPassword()">
      <div class="table-responsive">
        <!-- begin::Table -->
        <table id="tableConfirmation" class="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer">
          <thead>
            <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
              <th class="min-w-150"> {{utilityService.getResourceValue("Name")}}</th>
              <th class="min-w-150"> {{utilityService.getResourceValue("Email")}}</th>
              <th class="min-w-150"> {{utilityService.getResourceValue("Password")}}</th>
              <th class="min-w-150"> {{utilityService.getResourceValue("ConfirmPassword")}}</th>
            </tr>
          </thead>
          <tbody class="fw-bold text-gray-600 border-0">
            <tr class="trItem">
              <td>{{Name}}</td>
              <td>{{Email}}</td>
              <td>
                <BBSF-TextBox [options]="Password" [group]="SetUserPasswordForm"></BBSF-TextBox>
              </td>
              <td>
                <BBSF-TextBox [options]="PasswordConfirmation" [group]="SetUserPasswordForm"></BBSF-TextBox>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="text-center pt-7">
        <button id="ClosesetPasswordUserModal" #ClosesetPasswordUserModal type="button" aria-label="Close" class="btn btn-light me-3 btn-sm" (click)="modal.dismiss()">{{utilityService.getResourceValue("CancelLabel")}}</button>
        <button type="submit" class="btn btn-primary btn-sm">{{utilityService.getResourceValue("SaveLabel")}}</button>
      </div>
    </form>

  </div>
</ng-template>

<!-- Send Activation Email Modal -->
<ng-template #SendActivationEmailModal let-modal>
  <div class="modal-header pb-0 border-0 justify-content-end">
    <h5 class="modal-title" id="exampleModalLabel"></h5>
    <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-sm btn-icon btn-active-color-primary" (click)="modal.dismiss()">
      <span class="svg-icon svg-icon-1">
        <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
      </span>
    </button>
  </div>
  <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
    <div class="mb-13 text-center">
      <h1 class="mb-3">{{utilityService.getResourceValue("SendActivationEmail")}}</h1>
    </div>
    <div class="notice d-flex bg-light-warning rounded border-warning border border-dashed mb-10 p-6">
      <!--begin::Icon-->
      <!--begin::Svg Icon | path: icons/duotune/general/gen044.svg-->
      <span class="svg-icon svg-icon-2tx svg-icon-warning me-4">
        <span [inlineSVG]="'./src/assets/images/gen044.svg'"></span>
      </span>
      <!--end::Svg Icon-->
      <!--end::Icon-->
      <!--begin::Wrapper-->
      <div class="d-flex flex-stack flex-grow-1">
        <!--begin::Content-->
        <div class="fw-bold">
          <div class="fs-6 text-gray-700">
            {{utilityService.getResourceValue("ActivateConfirmation")}}
          </div>
        </div>
        <!--end::Content-->
      </div>
      <!--end::Wrapper-->
    </div>
    <div class="note note-warning text-center">
    </div>
    <div class="table-responsive">
      <!-- begin::Table -->
      <table id="tableConfirmation" class="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer">
        <thead>
          <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
            <th class="min-w-150">{{utilityService.getResourceValue("Name")}}</th>
            <th class="min-w-150">{{utilityService.getResourceValue("Email")}}</th>
            <th class="min-w-50" *ngIf="SelectedUserList.length>1">{{utilityService.getResourceValue("Action")}}</th>
          </tr>
        </thead>
        <tbody class="fw-bold text-gray-600 border-0">
          <tr *ngFor="let user of SelectedUserList" class="trItem">
            <td *ngIf="language=='en'" class="text-dark">{{user.name.english}}</td>
            <td *ngIf="language=='ar'" class="text-dark">{{user.name.arabic}}</td>

            <td>{{user.username}}</td>
            <td *ngIf="SelectedUserList.length>1">
              <button type="button" (click)="deleteUserFromList(user)"
                      class="btn btn-light-danger btn-icon btn-sm">
                <i class="fas fa-trash"></i>
              </button>
            </td>

          </tr>
        </tbody>
      </table>
    </div>
    <div class="text-center pt-7">
      <button #CloseActivationEmailModal id="CloseActivationEmailModal" type="button" aria-label="Close" class="btn btn-light me-3 btn-sm" (click)="modal.dismiss()">{{utilityService.getResourceValue("CancelLabel")}}</button>
      <button type="button" class="btn btn-primary btn-sm" (click)="sendActivationEmailForUser()">{{utilityService.getResourceValue("SaveLabel")}}</button>
    </div>
  </div>
</ng-template>

<!-- confirmation Message  Modal -->
<ng-template #ConfirmationModal let-modal>
  <div class="modal-header pb-0 border-0 justify-content-end">
    <h5 class="modal-title" id="exampleModalLabel"></h5>
    <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-sm btn-icon btn-active-color-primary" (click)="modal.dismiss()">
      <span class="svg-icon svg-icon-1">
        <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
      </span>
    </button>
  </div>
  <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
    <div class="mb-13 text-center">
      <h1 class="mb-3">{{utilityService.getResourceValue("ConfirmationMessage")}}</h1>
    </div>
    <div class="notice d-flex bg-light-warning rounded border-warning border border-dashed mb-10 p-6">
      <!--begin::Icon-->
      <!--begin::Svg Icon | path: icons/duotune/general/gen044.svg-->
      <span class="svg-icon svg-icon-2tx svg-icon-warning me-4">
        <span [inlineSVG]="'./src/assets/images/gen044.svg'"></span>
      </span>
      <!--end::Svg Icon-->
      <!--end::Icon-->
      <!--begin::Wrapper-->
      <div class="d-flex flex-stack flex-grow-1">
        <!--begin::Content-->
        <div class="fw-bold">
          <div class="fs-6 text-gray-700">
            {{ConfirmationMessage}}
          </div>
        </div>
        <!--end::Content-->
      </div>
      <!--end::Wrapper-->
    </div>
    <div class="table-responsive">
      <!-- begin::Table -->
      <table id="tableConfirmation" class="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer">
        <thead>
          <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
            <th class="min-w-150">{{utilityService.getResourceValue("Name")}}</th>
            <th class="min-w-150">{{utilityService.getResourceValue("Email")}}</th>
            <th class="min-w-50" *ngIf="SelectedUserList.length>1">{{utilityService.getResourceValue("Action")}}</th>
          </tr>
        </thead>
        <tbody class="fw-bold text-gray-600 border-0">
          <tr *ngFor="let user of SelectedUserList" class="trItem">
            <td *ngIf="language=='en'" class="text-dark">{{user.name.english}}</td>
            <td *ngIf="language=='ar'" class="text-dark">{{user.name.arabic}}</td>

            <td>{{user.username}}</td>
            <td *ngIf="SelectedUserList.length>1">
              <button type="button" (click)="deleteUserFromList(user)"
                      class="btn btn-light-danger btn-icon">
                <i class="fas fa-trash"></i>
              </button>
            </td>

          </tr>
        </tbody>
      </table>
    </div>
    <div class="text-center pt-7">
      <button #CloseConfirmationModal id="CloseConfirmationModal" class="btn btn-light me-3 btn-sm" (click)="modal.dismiss()">
        {{utilityService.getResourceValue("CancelLabel")}}
      </button>

      <button type="button" *ngIf="ConfirmationModalType==1" (click)="activateUserList()"
              class="btn btn-primary btn-sm">
        {{utilityService.getResourceValue("SaveLabel")}}
      </button>
      <button type="button" *ngIf="ConfirmationModalType==2" (click)="deactivateUserList()"
              class="btn btn-primary btn-sm">
        {{utilityService.getResourceValue("SaveLabel")}}
      </button>
      <button type="button" *ngIf="ConfirmationModalType==3" (click)="resetUserPasswordList()"
              class="btn btn-primary btn-sm">
        {{utilityService.getResourceValue("SaveLabel")}}
      </button>
      <button type="button" *ngIf="ConfirmationModalType==4" (click)="sendActivationEmailForUser()"
              class="btn btn-primary btn-sm">
        {{utilityService.getResourceValue("SaveLabel")}}
      </button>

    </div>
  </div>
</ng-template>



